import {
  Backdrop,
  CircularProgress,
  CircularProgressProps,
} from "@mui/material";

interface ILoader {
  color?: CircularProgressProps["color"];
  size?: number | string;
}

function Loader({ color = "inherit", size = "40px" }: ILoader) {
  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={true}
    >
      <CircularProgress color={color} size={size} />
    </Backdrop>
  );
}

export default Loader;
